import React, { useState } from "react";
import { Link } from "react-router-dom";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  Input,
  Label,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import classnames from "classnames";
import COOPDetail from "./COOPDetails";
import ExecutiveForm from "./ExecutiveForm";
import LekhaSuparibechan from "./LekhaSuparibechan";
import { createSelector } from "reselect";
import LoginDetail from "./LoginDetail";

const PublicPortal = ({formik}) => {
  const [activeTab, setActiveTab] = useState("1");
  const [profileImage, setProfileImage] = useState(null); // Change to null initially
  const [coverImage, setCoverImage] = useState("/background.jpg");
  const [facebookLink, setFacebookLink] = useState("https://facebook.com");
  const [twitterLink, setTwitterLink] = useState("https://twitter.com");

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfileImage(file);
    }
  };

  const tabChange = (tab) => {
    if (activeTab !== tab) setActiveTab(tab);
  };

  const handleCoverChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setCoverImage(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleCoverImageClick = () => {
    document.getElementById("cover-img-file-input").click();
  };

  const handleUserProfileImageClick = () => {
    document.getElementById("profile-img-file-input").click();
  };

  const user = JSON.parse(localStorage.getItem("user"));
  const selectDashboardData = createSelector(
    (state) => state.Layout.sidebarVisibilitytype,
    (sidebarVisibilitytype) => sidebarVisibilitytype
  );

  const userImage = user?.user?.image;
  const userImageExtension = user?.user?.imageExtension;
  const imageSrc = userImageExtension
    ? `data:image/${userImageExtension.replace(".", "")};base64,${userImage}`
    : "No Image";

  return (
    <React.Fragment>
      <div className="">
        <div className="page-content">
          <Container fluid>
            <div className="position-relative mx-n4 mt-n4">
              <img
                src={coverImage}
                className="avatar-xl w-100"
                style={{ width: "100px", height: "300px" }}
                alt="cover-image"
                onClick={handleCoverImageClick}
              />

              <div className="overlay-content text-end p-3 p-0 position-absolute top-0 end-0">
                <div className="d-flex gap-3">
                  <label
                    htmlFor="cover-img-file-input"
                    className="custom-file-input-label btn btn-light"
                    style={{ width: "200px", height: "100" }}
                  >
                    Change Cover
                  </label>
                  <input
                    id="cover-img-file-input"
                    type="file"
                    className="cover-img-file-input"
                    onChange={handleCoverChange}
                    accept="image/*"
                    style={{ display: "none" }}
                  />

                  <Link
                    to={"/view-profile"}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <Button
                      className=" btn btn-light"
                      style={{ width: "200px", height: "100" }}
                    >
                      View profile
                    </Button>
                  </Link>
                </div>
              </div>
            </div>

            <Row>
              <Col lg={3}>
                <Card className="mt-n5">
                <CardBody className="p-4">
                    <div className="text-center">
                      <div
                        className="profile-user position-relative d-inline-block mx-auto mb-4"
                        onClick={handleUserProfileImageClick}
                      >
                        <img
                          src={
                            profileImage
                              ? URL.createObjectURL(profileImage)
                              : imageSrc
                          }
                          className="rounded-circle avatar-xl img-thumbnail user-profile-image"
                          alt="user-profile"
                        />

                        <div className="avatar-xs p-0 rounded-circle profile-photo-edit">
                          <input
                            id="profile-img-file-input"
                            type="file"
                            className="profile-img-file-input"
                            onChange={handleImageChange}
                            accept="image/*"
                            style={{ display: "none" }}
                          />
                          <Label
                            htmlFor="profile-img-file-input"
                            className="profile-photo-edit avatar-xs"
                          >
                            <span className="avatar-title rounded-circle bg-light text-body">
                              <i
                                className="ri-camera-fill"
                                onClick={handleUserProfileImageClick}
                              ></i>
                            </span>
                          </Label>
                        </div>
                      </div>
                    </div>
                  </CardBody>
                </Card>

                <Card>
                  <CardBody>
                    <div className="d-flex align-items-center mb-4">
                      <div className="flex-grow-1">
                        <h5 className="card-title mb-0">Social Media Links</h5>
                      </div>
                    </div>
                    {/* Facebook Link */}
                    <div className="mb-3 d-flex">
                      <div className="avatar-xs d-block flex-shrink-0 me-3">
                        <h2>
                          <i className="ri-facebook-box-fill text-secondary"></i>
                        </h2>
                      </div>
                      <Input
                        type="text"
                        className="form-control clickable-input text-color-primary"
                        placeholder="Facebook Link"
                        value={facebookLink}
                        onChange={(e) => setFacebookLink(e.target.value)}
                      />
                    </div>

                    {/* Twitter Link */}
                    <div className="mb-3 d-flex">
                      <div className="avatar-xs d-block flex-shrink-0 me-3">
                        <h2>
                          <i className="ri-twitter-fill text-info"></i>
                        </h2>
                      </div>
                      <Input
                        type="text"
                        className="form-control clickable-input text-color-primary"
                        placeholder="Twitter Link"
                        value={twitterLink}
                        onChange={(e) => setTwitterLink(e.target.value)}
                      />
                    </div>
                  </CardBody>
                </Card>
              </Col>

              <Col lg={9}>
              <Card className="mt-lg-n5">
                    <CardHeader>
                      <Nav
                        className="nav-tabs-custom rounded card-header-tabs border-bottom-0"
                        role="tablist"
                      >
                        <NavItem>
                          <NavLink
                            className={classnames({ active: activeTab === "1" })}
                            onClick={() => {
                              tabChange("1");
                            }}
                          >
                            <i className="fas fa-home"></i>
                            COOP Details
                          </NavLink>
                        </NavItem>
                        {/* <NavItem>
                          <NavLink
                            className={classnames({ active: activeTab === "2" })}
                            onClick={() => {
                              tabChange("2");
                            }}
                          >
                            <i className="fas fa-home"></i>
                            Login Details
                          </NavLink>
                        </NavItem> */}
                        <NavItem>
                          <NavLink
                            to="#"
                            className={classnames({ active: activeTab === "2" })}
                            onClick={() => {
                              tabChange("2");
                            }}
                            type="button"
                          >
                            <i className="far fa-user"></i>
                            Executive Committee
                          </NavLink>
                        </NavItem>
                        <NavItem>
                          <NavLink
                            to="#"
                            className={classnames({ active: activeTab === "3" })}
                            onClick={() => {
                              tabChange("3");
                            }}
                            type="button"
                          >
                            <i className="far fa-envelope"></i>
                            Lekha Suparibechan Committee
                          </NavLink>
                        </NavItem>
                      </Nav>
                    </CardHeader>
                    <CardBody className="p-4">
                      <TabContent activeTab={activeTab}>
                        <TabPane tabId="1">
                          <COOPDetail
                            setActiveTab={setActiveTab}
                            profileImage={profileImage}
                          />
                        </TabPane>
                        {/* <TabPane tabId="2">
                          <LoginDetail
                          setActiveTab={setActiveTab} formik={formik}/>
                        </TabPane> */}
                        <TabPane tabId="2">
                          <ExecutiveForm setActiveTab={setActiveTab} />
                        </TabPane>
                        <TabPane tabId="3">
                          <LekhaSuparibechan setActiveTab={setActiveTab} />
                        </TabPane>
                      </TabContent>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      </React.Fragment>
    );
  };
  
  export default PublicPortal;
